import React, { useContext } from 'react'
import { HomePageFooter } from '../commonComponents/HomePageComponents'
import { SharedContext } from '@/context/SharedContext'
import { SeekerContext } from '@/context/SeekerContext'

export const DesktopSeekerFooter = ({ footerCategories, footerLocations }) => {
  const { location, setLocation } = useContext(SharedContext);
  const { filterTitleIds, setBody } = useContext(SeekerContext);

  const navigateToListing = (type, id) => {
    const value = (type == 'location' ? footerLocations : footerCategories)?.find(
      (item) => item?.id == id
    )
    if (type != 'noBody' && type != 'location') {
      const bodyValue = {
        [filterTitleIds['Job Category']]: [value]
      }
      setBody((prv) => ({
        ...prv,
        selectedOptions: bodyValue
      }))
    }

    if (type == 'location') setLocation(value)

    return {
      isNewPath: true,
      newPath:
        type == 'noBody'
          ? '/jobs/jobs-near-me'
          : type == 'location'
          ? `/jobs/jobs-in-${value?.short_name || ''}`
          : `/jobs/${(value?.english_name)
      .replace(/ /g, '')
      ?.replace(/\//g, '-and-')
      ?.replace('&', '-and-')}-jobs-in-${location?.name || location?.title}`
    }
  }
  const navigateToPostJob = () => {
    window?.open(process.env.NEXT_PUBLIC_APP_URL + 'hire', '_self')
    return true
  }
  const navigateToLogin = () => {
    // setMenuClicked(true)
  }

  const navigateToSiteMap = (type) => {
    return {
      isNewPath: true,
      newPath: '/jobs/sitemap',
      query: { elementTitle: type }
    }
  }

  return (
    <div>
      <HomePageFooter
        {...{
          navigateToListing,
          navigateToPostJob,
          navigateToLogin,
          footerCategories: footerCategories,
          footerLocations: footerLocations,
          isLogin: true,
          isAdvertiser: true,
          navigateToSiteMap
        }}
      />
    </div>
  )
}
